import { useCallback, useMemo } from 'react';
import IPrice from '../../model/IPrice';
import usePlatformConfig from '../../../../common/react/usePlatformConfig';

const usePriceValidation = (prices: IPrice[]) => {
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();

  const hasSecondaryCurrency = useCallback(() => !!priceDisplay!.secondary, [priceDisplay]);
  const hasDifferentCurrencies = useCallback(() => priceDisplay.primary.currency !== priceDisplay.secondary?.currency, [
    priceDisplay,
  ]);

  const isMultiCurrency = useMemo(() => hasSecondaryCurrency() && hasDifferentCurrencies(), [priceDisplay, prices]);

  return { isMultiCurrency };
};

export default usePriceValidation;
